import { useTranslation } from "react-i18next";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import CardNavButton from "UIPalette/CardNavButton/CardNavButton";
import { ReactComponent as WisdomAILogo } from "shared/assets/Icons/wisdom-ai-full.svg";
import WisdomAIImage from "shared/assets/wisdom-ai.svg";
import { EventNames } from "core/monitoring/types/enums";
import { trackEvents } from "core/monitoring/Events";
import { useWisdomAIEntry } from "../../../WisdomAI/hooks/useWisdomAIEntry";

export const WisdomAICard = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "home.wisdomAICard" });
  const { enterWisdomAI, comingSoon } = useWisdomAIEntry();

  return (
    <RoundedCard className="flex flex-col !p-0 overflow-hidden h-72">
      <div className="flex min-h-0 flex-1 flex-col px-6 pt-6">
        <h2 className="!pb-1">
          <WisdomAILogo aria-hidden="true" focusable="false" width="170" height="40" />
          <span className="sr-only">{t("title")}</span>
        </h2>
        <p>{t("description")}</p>
        <div className="flex min-h-0 flex-1 items-end justify-center">
          <img src={WisdomAIImage} alt="" className="max-h-full w-auto" data-testid="wisdom-ai-card-image" />
        </div>
      </div>
      <CardNavButton
        label={t("navLabel")}
        onClick={() => {
          trackEvents(EventNames.WISDOM_AI_CARD_CLICK);
          enterWisdomAI();
        }}
      />
      {comingSoon}
    </RoundedCard>
  );
};
